export enum LanguageType {
    Russian = 1,
    English = 2,
}
